/**
 * this DB is created due to when a variant is added to cart
 * and there is not availability, shopify return a 422 status code.
 * If that happens we need to save the item with no inventory to added
 * in other process
 */

/**
 * this class works as a DB to storage item that will need
 * to add to the cart
 */
class CartDB {

  constructor() {
    this.key = 'cart-db'
    this.pending = null

    this.getPendingFromDB()
  }

  clearPending() {
    localStorage.setItem(this.key, null)
  }

  getPendingFromDB() {
    const pending = JSON.parse(localStorage.getItem(this.key) || null)

    this.pending = pending
    return this.pending
  }

  async insertPendingOnCart() {
    const pending = this.getPendingFromDB()

    const addProductsToCart = window.proficient.utils.addProductsToCart

    if( !addProductsToCart ) {
      return false
    }

    const item = JSON.parse(pending)

    if( !item['id'] ) {
      throw new Error('id is mandatory in pending item')
    } 
    if( !item['quantity'] ) {
      throw new Error('id is mandatory in pending item')
    } 

    try {
      const data = await addProductsToCart(item)
      console.log(data)
      this.clearPending()
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * this sets the pending item to cart in localStorage
   * @param { { id: number, quantity: number, properties: any } } item
   */
  setPending(item){
    localStorage.setItem(this.key, JSON.stringify(item))
  }
}

let cartDB = null

window.addEventListener('DOMContentLoaded', () => {
  cartDB = new CartDB()
})
